<script>
  import { createEventDispatcher } from "svelte";
  import { Loading } from "carbon-components-svelte";

  export let accept = [];
  export let files = [];
  export let multiple = false;
  export let disabled = false;
  export let disableLabelChanges = false;
  export let role = "button";
  export let id = "ccs-" + Math.random().toString(36);
  export let name = "";
  export let ref = null;
  export let color = "orange";
  export let secondary = false;
  export let danger = false;
  export let enlarge = false;
  export let loading = false;
  export let showText = true;
  export let iconLeft = false;
  export let iconRight = false;

  export let text = "Add file";
  export let icon = "arrow_right";

  const dispatch = createEventDispatcher();

  let initialLabelText = text;

  $: if (ref && files.length === 0) {
    text = initialLabelText;
    ref.value = "";
  }
</script>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<label
  for={id}
  tabindex="0"
  class={`mainbutton ${color === "white" ? "white_button" : ""} ${
    enlarge === true ? "enlarge" : ""
  } ${secondary === true ? "secondary" : ""} ${danger === true ? "danger" : ""} ${disabled ? "disabled" : ""}`}
  on:keydown
  on:keydown={({ key }) => {
    if (key === " " || key === "Enter") {
      ref.click();
    }
  }}
>
  <span {role}>
    {#if loading === true}
      <Loading small withOverlay={false} active={loading}></Loading>
    {:else}{#if iconLeft === true}
        <div class="icon">
          <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
        </div>
      {/if}
      {#if showText === true}
        <div class="button_text">{text}</div>
      {/if}
      {#if iconRight === true}
        <div class="icon">
          <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
        </div>
      {/if}
    {/if}
  </span>
</label>
<input
  bind:this={ref}
  type="file"
  tabindex="-1"
  {accept}
  {disabled}
  {id}
  {multiple}
  {name}
  class:bx--visually-hidden={true}
  {...$$restProps}
  on:change|stopPropagation={({ target }) => {
    files = [...target.files];

    if (files && !disableLabelChanges) {
      text = files.length > 1 ? `${files.length} files` : files[0].name;
    }

    dispatch("change", files);
  }}
  on:click
  on:click={({ target }) => {
    target.value = null;
  }}
/>

<style>
  .mainbutton {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem !important;
    gap: 1rem;
    padding: 0.8rem 1.2rem;
    border-radius: 0.5rem;
    background-color: #ff5f1f;
    width: fit-content;
    color: white;
    transition: 300ms ease-in-out !important;
    cursor: pointer;
    user-select: none;
  }

  .mainbutton:hover {
    background-color: #2a2a2f;
  }
  .white_button {
    background-color: white;
    color: var(--pax-black);
  }

  .white_button:hover {
    background-color: #ffffff80;
  }

  .secondary {
    background-color: var(--pax-black);
    user-select: none;
    color: white;
  }

  .secondary:hover {
    background-color: #1c1c2080;
    color: white;
  }

  .danger {
    background-color: var(--pax-danger);
    color: white;
  }

  .danger:hover {
    background-color: #ff000080;
    color: white;
  }
</style>
